<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    新秀站<br>
站点介绍<br>
新秀站是二号线蛇口线东延段终点站，车站位于深圳市罗湖区新秀路与罗芳路交汇处东侧，南方大厦与通发花园之间，沿新秀路呈东西走向布置。该处为罗湖区的交通干道，车站正上方为新秀路，西侧为罗芳路。紧邻罗芳小学，西侧有新秀市场、古玩城。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:02	23:35	2号线	2分35秒	5分45秒<br>
莲塘	06:26	00:05	2号线	2分35秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:00	23:34	2号线	4分钟	5分钟<br>
莲塘	06:26	00:05	2号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:00	00:24	2号线	4分钟	5分钟<br>
莲塘	06:26	01:05	2号线	4分钟	5分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
新秀路（西）、罗芳路、深圳市罗湖外语学校初中实验部、罗芳小学、古玩城、南方大厦、新秀村、新秀小学<br><br>
B出入口:<br>
新秀路（东）、罗坊西山、华兴花园、通发花园、金枫花园<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 新秀小学<br>
69、85、111、218、220、381、M133、M383、N14<br><br>
B出入口:<br>
公交站名： 新秀地铁站<br>
B621<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>